module.exports = __webpack_public_path__ + "static/procesProdukcjaDesktop@x1-b3afe8d5cd5e493f89787b47301d0b37.png";